const Messages = () => {
  return (
    <div className="content-page-admin">
      <div className="title-page-admin">
        <i className="bx bx-message"></i>
        <p>Messages page</p>
      </div>
    </div>
  );
};

export default Messages;
